/**
 * Just-in-time tutorials: a few short steps shown the first time a level
 * with that tutorial id is opened. `demo` asks the renderer to animate a
 * hand performing the action instead of explaining it in text.
 */
export type TutorialFocus = "first-item" | "bins" | "undo" | "hint" | "queue" | "pedestal" | "stack" | "moves";

export interface TutorialStep {
  readonly text: string;
  readonly focus?: TutorialFocus;
  readonly demo?: "drag-first-item";
}

export interface Tutorial {
  readonly id: string;
  readonly steps: readonly TutorialStep[];
}

export const SORTING_TUTORIALS: readonly Tutorial[] = [
  {
    id: "drag-to-bin",
    steps: [
      { text: "Kéo món đồ vào khay có hình giống nó nha!", focus: "first-item", demo: "drag-first-item" },
    ],
  },
  {
    id: "read-labels",
    steps: [{ text: "Nhìn hình trên mỗi khay là biết khay đang thèm món gì liền.", focus: "bins" }],
  },
  {
    id: "undo",
    steps: [{ text: "Lỡ tay đặt nhầm? Chạm Hoàn tác là quay ngược thời gian liền!", focus: "undo" }],
  },
  {
    id: "size-sort",
    steps: [{ text: "Lần này khay chỉ quan tâm to hay nhỏ thôi nè!", focus: "bins" }],
  },
  {
    id: "shape-sort",
    steps: [{ text: "Khay này chỉ để ý hình dạng thôi, là sao, tim hay tròn nè.", focus: "bins" }],
  },
  {
    id: "two-rules",
    steps: [{ text: "Khay này kén lắm nha, phải đúng cả màu lẫn hình luôn!", focus: "bins" }],
  },
  {
    id: "capacity-queue",
    steps: [
      { text: "Đồ xếp hàng đi tới, chỉ lấy được món đứng đầu hàng thôi nha.", focus: "queue" },
      { text: "Mỗi khay chứa được số món có hạn, tính trước cho khéo nha!", focus: "bins" },
    ],
  },
  {
    id: "magic-bell",
    steps: [
      { text: "Đặt chuông phép lên bệ là luật của các khay đổi liền!", focus: "pedestal" },
      { text: "Xếp xong luật cũ rồi hẵng rung chuông nha!", focus: "bins" },
    ],
  },
  {
    id: "many-groups",
    steps: [{ text: "Khay đông vui hơn rồi! Bạn kéo đồ từ khay này sang khay kia cũng được nha.", focus: "bins" }],
  },
  {
    id: "stack-order",
    steps: [{ text: "Lọ thủy tinh xếp chồng, món bự nằm dưới, nhỏ dần lên trên.", focus: "stack" }],
  },
  {
    id: "move-limit",
    steps: [{ text: "Màn này có giới hạn lượt. Hết lượt thì chơi lại, không mất gì đâu!", focus: "moves" }],
  },
  {
    id: "hint",
    steps: [{ text: "Bí quá hả? Bóng đèn gợi ý sẽ chỉ đường. Mỗi màn có 2 lượt miễn phí, hết thì đổi vàng, mà xài gợi ý thì màn đó chỉ còn 1 sao thôi nha.", focus: "hint" }],
  },
];

export const TUTORIAL_BY_ID: ReadonlyMap<string, Tutorial> = new Map(
  SORTING_TUTORIALS.map((tutorial) => [tutorial.id, tutorial]),
);
